<template>
    <div>
        <accordion level3 id="sub_aneel13_1" title="Comprovantes XML" sub accordion="sub_aneel13_1" visible>
            <div class="p-3 row">
                <input-date-time class="col-12 col-md-3" :disabled="readonly" label="Data do envio" v-model="form.data" ref="form1-data" required type="date"/>
                <input-text class="col-12 col-md-3" :disabled="readonly" label="Versão XML" v-model="form.versao" ref="form1-versao" required/>
                <div class="col-12 mb-2">
                    <div class="text-muted">
                        Comprovante XML
                    </div> 
                    <upload 
                        id="aneel13"
                        tituloArquivo="Arrastar Arquivo" 
                        selecioneArquivo="Selecionar Arquivo" 
                        type=".*"
                        
                        @upload="(file, nomeArquivo)=> {                   
                            form.nomeArquivoAWS = nomeArquivo;
                            form.conteudoBase64 = file;
                        }" />
                </div>   
                <div class="col-12" v-if="!readonly">
                    <b-button v-if="permissao.c" variant="success" @click="$emit('salvar',form)">
                        <i class="fa-solid fa-cloud-arrow-up mr-2"></i>
                        Upload comprovante XML
                    </b-button>
                </div>     
                <div class="col-12 mt-3">
                    <h6>Lista de comprovantes</h6>
                    <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
                        <template  #cell(actions)="data">
                            <div class="d-inline-flex">
                                <b-button variant="flat-primary" v-if="!readonly" class="mr-2" @click="$emit('download', data.item.id)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                                <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </accordion>
        <accordion level3 id="sub_aneel13_2" title="Comprovantes PDF" sub accordion="sub_aneel13_2" visible>
            <div class="p-3 row">
                <input-date-time class="col-12 col-md-3" :disabled="readonly" label="Data do envio" v-model="form2.data" ref="form2-data" required type="date"/>
                <input-text class="col-12 col-md-3" :disabled="readonly" label="Versão XML" v-model="form2.versao" ref="form2-versao" required/>
                <div class="col-12 mb-2">
                    <div class="text-muted">
                        Comprovante PDF
                    </div> 
                    <upload 
                        id="aneel13_2"
                        tituloArquivo="Arrastar Arquivo" 
                        selecioneArquivo="Selecionar Arquivo" 
                        type=".pdf"
                        
                        @upload="(file, nomeArquivo)=> {                   
                            form2.nomeArquivoAWS = nomeArquivo;
                            form2.conteudoBase64 = file;
                        }" />
                </div>   
                <div class="col-12" v-if="!readonly">
                    <b-button v-if="permissao.c" variant="success" @click="$emit('salvar',form2)">
                        <i class="fa-solid fa-cloud-arrow-up mr-2"></i>
                        Upload comprovante PDF
                    </b-button>
                </div>     
                <div class="col-12 mt-3">
                    <h6>Lista de comprovantes</h6>
                    <b-table head-variant="dark" hover :fields="table.fields" :items="itens2">
                        <template  #cell(actions)="data">
                            <div class="d-inline-flex">
                                <b-button variant="flat-primary" v-if="!readonly" class="mr-2" @click="$emit('download2', data.item.id)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                                <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar2', data.item.id)"><i class="fas fa-trash"></i></b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>        
        </accordion>
        
    </div>
</template>
<script>
import InputDateTime from '@/components/inputs/InputDateTime';
import InputText from '@/components/inputs/InputText';
import Upload from '@/components/upload/Upload';

import helpers from '@/common/utils/helpers';
import {FormMixin} from '@/common/mixins/FormMixin';
import Accordion from '@/components/card/Accordion';
export default {
    name: "Annel13",
    mixins: [FormMixin],
    components: {
        InputDateTime,
        Upload,
        InputText,
        Accordion
    },   
    props: {
        itens : {
            
            default: () => []
        },
        itens2 : {
            
            default: () => []
        },
        idUpload: {
            type: String,
            require
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data: () => ({
        form : {
            arquivoObrigatorio : [
                {
                    nomeCampo : 'Comprovante',
                    campo : 'conteudoBase64',
                }
            ],
            data: null,
            nomeArquivoAWS: "",
            versao: 0,
            conteudoBase64: null
        },
        form2 : {
            form2 : true,
            arquivoObrigatorio : [
                {
                    nomeCampo : 'Comprovante',
                    campo : 'conteudoBase64',
                }
            ],
            data: null,
            nomeArquivoAWS: "",
            versao: 0,
            conteudoBase64: null
        },
        table : {
            fields : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão XML"},
                { key: "data", label:"Data de envio",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "actions", label:"Ações"},
            ]
        },
        options : {
            regra : helpers.getRegrasProjetos()
        }
    }),    
    watch: {
        itens: {
            handler: function(newValue) {
                this.form.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        },
        itens2: {
            handler: function(newValue) {
                this.form2.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        }
    },
    computed :{
        readonly :function(){
            return this.$route.name != 'projeto-detalhamento' || !this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdObrigacoesAneel');
        },
    }
}
</script>
<style lang="">
    
</style>